export default function findLargeGroupAndFieldTrip(activities) {
  const largeGroup = activities.find(
    ({ largeGroup, fieldTrip }) => largeGroup && !fieldTrip
  )
  const fieldTrip = activities.find(
    ({ largeGroup, fieldTrip }) => largeGroup && fieldTrip
  )
  return { largeGroup, fieldTrip }
}
